'use client';

import { useClerkGoogleSignIn } from '@lib/clerk/hooks/use-clerk-google-signin';
import { UseGoogleSignInReturn } from '../types';

/**
 * Hook for Google OAuth sign-in
 *
 * Orchestrates authentication flow between Clerk and Supabase based on feature flags.
 * The component using this hook is responsible for managing loading state.
 *
 * @example
 * ```tsx
 * function SignInButton() {
 *   const [isLoading, setIsLoading] = useState(false)
 *   const { signInWithGoogle, error } = useGoogleSignIn()
 *
 *   const handleClick = async () => {
 *     setIsLoading(true)
 *     try {
 *       await signInWithGoogle('/dashboard')
 *     } catch (err) {
 *       console.error(err)
 *     } finally {
 *       setIsLoading(false)
 *     }
 *   }
 *
 *   return <button onClick={handleClick}>Sign In</button>
 * }
 * ```
 */
export function useGoogleSignIn() {
  return useClerkGoogleSignIn();
}